module.exports = __webpack_public_path__ + "static/media/help.c6fea0e4.svg";